import { useState } from "react";
import { signInWithEmailAndPassword } from "firebase/auth";
import {
  doc,
  getDoc,
  getDocs,
  query,
  where,
  collection,
  setDoc,
  serverTimestamp,
} from "firebase/firestore";
import { auth, db } from "../../firebaseConfig";

export default function FpoLogin() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);

    try {
      const cred = await signInWithEmailAndPassword(auth, email, pass);
      const uid = cred.user.uid;
      const userEmail = (cred.user.email || email || "").toLowerCase().trim();

      // ✅ 1) First try: UID based doc
      let snap = await getDoc(doc(db, "farmer_vendors", uid));

      // ✅ 2) If not found, try to find by email and auto-fix (migrate) into UID doc
      if (!snap.exists()) {
        // Try email field
        const q1 = query(collection(db, "farmer_vendors"), where("email", "==", userEmail));
        const s1 = await getDocs(q1);

        let found = null;

        if (!s1.empty) {
          found = s1.docs[0];
        } else {
          // Try auth.email field (if stored that way)
          const q2 = query(collection(db, "farmer_vendors"), where("auth.email", "==", userEmail));
          const s2 = await getDocs(q2);
          if (!s2.empty) found = s2.docs[0];
        }

        if (found) {
          const data = found.data() || {};

          // ✅ Copy existing profile into UID doc so future logins work permanently
          await setDoc(
            doc(db, "farmer_vendors", uid),
            {
              ...data,
              email: userEmail,
              auth: { ...(data.auth || {}), email: userEmail },
              migratedFromDocId: found.id,
              migratedAt: serverTimestamp(),
              updatedAt: serverTimestamp(),
            },
            { merge: true }
          );

          // reload UID doc
          snap = await getDoc(doc(db, "farmer_vendors", uid));
        }
      }

      // ✅ 3) Final check
      if (!snap.exists()) {
        alert("Access denied: FPO profile not found. Please contact Society Admin.");
        return;
      }

      const data = snap.data() || {};
      if (String(data.status || "") !== "approved") {
        alert("Access denied: FPO not approved by Society.");
        return;
      }

      window.location.href = "/fpo/dashboard";
    } catch (err) {
      console.error("FPO Login Error:", err);
      alert(`${err.code || "no-code"} : ${err.message || err}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200 shadow p-6">
        <div className="text-xs uppercase tracking-widest text-emerald-700 font-semibold">
          FPO / Cooperative Portal
        </div>
        <h1 className="text-2xl font-extrabold text-slate-900 mt-1">Login</h1>

        <form onSubmit={login} className="mt-5 space-y-3">
          <div>
            <label className="text-sm font-semibold">Email</label>
            <input
              className="mt-1 w-full border border-slate-300 rounded-lg p-2.5"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="fpo@example.com"
              type="email"
              required
            />
          </div>

          <div>
            <label className="text-sm font-semibold">Password</label>
            <input
              className="mt-1 w-full border border-slate-300 rounded-lg p-2.5"
              value={pass}
              onChange={(e) => setPass(e.target.value)}
              placeholder="••••••••"
              type="password"
              required
            />
          </div>

          <button
            disabled={loading}
            className="w-full mt-2 bg-emerald-600 text-white font-semibold rounded-lg py-2.5 hover:bg-emerald-700 disabled:opacity-60"
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </form>
      </div>
    </div>
  );
}
